import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import DomainBuyItNowToggle from "../DomainBuyItNowToggle";
// TODO: Consolidate DatePicker cells into single cell
var ToggleBuyItNowCell = function (_a) {
    var _b = _a.row, index = _b.index, originalDomainObj = _b.original, id = _a.column.id;
    return _jsx(DomainBuyItNowToggle, { user: originalDomainObj.owner, data: originalDomainObj, isToggled: originalDomainObj.buyItNow }, "".concat(originalDomainObj, "-").concat(id, "-").concat(index));
};
export default ToggleBuyItNowCell;
